import React, {useEffect, useState} from "react";
import {useForceUpdate} from "../../services/misc.functions";
import {useDailyRaces} from "../../features/bulletin/bulletin.store";
import {homeHippodrome, homeHippodromeSubject, tipstersData} from "../../store/misc.store";
import {ApiService} from "../../lib/http.service";
import {env} from "../../constants/global.vars";
import {isMobile} from "../../App";
import {HippodromeWidget} from "../../shared/hippodrome/hippodrome";
import {MutualBetslip} from "../../features/betslip/mutual.service";
import {ScrollArrows, useHorizontalScroller} from "../../shared/hippodrome/scroll-arrows";

export function Comments() {
    const scroller = useHorizontalScroller();
    const [tipstersMap, setTipstersMap] = useState<any>({});
    const [tipsters, setTipsters] = useState<any>(null);
    const [selectedTipster, setSelectedTipster] = useState<any>(null);
    const [selectedTip, setSelectedTip] = useState<any>(null);

    const forceUpdate = useForceUpdate();
    // Bülten güncellemesinde yeniden çizim artık anlık görüntüden geliyor.
    const dailyRaces = useDailyRaces();


    useEffect(() => {
        let homeHippodromeSubject_subscription = homeHippodromeSubject.subscribe((res: any) => {
            forceUpdate();
            getTipsterComments();
        })

        return () => {
            homeHippodromeSubject_subscription.unsubscribe();
        }

    }, []);

    const getTipsterComments = () => {
        if (homeHippodrome) {
            let api = new ApiService()
            api.start('get', `${env.api}/misc/api/racing-tip/`, null, false)
                .then((res: any) => {
                    var tipsterMap: any = {};
                    var _tipsters = [];
                    for (const tipstersCommentDatumElement of res.data) {
                        if (tipstersCommentDatumElement?.card_id?.toString() === homeHippodrome?.card_id?.toString()) {
                            if (tipsterMap[tipstersCommentDatumElement.tipster.id]) {
                                tipsterMap[tipstersCommentDatumElement.tipster.id].push(tipstersCommentDatumElement)
                            } else {
                                tipsterMap[tipstersCommentDatumElement.tipster.id] = [];
                                tipsterMap[tipstersCommentDatumElement.tipster.id].push(tipstersCommentDatumElement)
                                _tipsters.push(tipstersCommentDatumElement.tipster);
                            }
                        }
                    }
                    try {
                        setTipsters(_tipsters);
                        setSelectedTipster(_tipsters[0]);
                        setTipstersMap(tipsterMap);
                        setSelectedTip(tipsterMap[_tipsters[0].id][0])
                    } catch (e: any) {
                    }
                    forceUpdate();
                })
        }
    };

    useEffect(() => {
        getTipsterComments();
    }, [homeHippodrome]);

    const handleTipsterChange = (tipster: any) => {
        setSelectedTipster(tipster);
        setSelectedTip(tipstersMap[tipster.id][0]);
    }

    if (!selectedTipster === null || tipsters == null || tipsters.length == 0) {
        return <>
            {isMobile ? <div className="page-title-wrapper ">
                <HippodromeWidget/>
            </div> : <div className={"page-title-wrapper sticky-page-title"}>
                <div className="hipodrome-tab-container">
                    <div className="container">
                        <div>
                            <div className={"hippodrome-scroller"}>
                                <ScrollArrows scroller={scroller}/>
                                <div className="tab-items-wrapper tab-items-scrollable" ref={scroller.ref}>
                                    {dailyRaces.map((data: any, key: any) => {
                                        return <div key={`available-hippodrome-${key}`}
                                                    className={`result-tab ${data.keyword === homeHippodrome?.keyword ? 'result-selected' : ''} `}
                                                    onClick={() => {
                                                        Object.assign(homeHippodrome, data);
                                                        homeHippodromeSubject.next(data);
                                                        MutualBetslip.setOptions({hippodrome: data});
                                                        forceUpdate();
                                                    }}>
                                            <div
                                                className={`tab-item ${data.keyword === homeHippodrome?.keyword ? 'selected' : ''} `}>
                                                <p className={`text-small text-bolder ${data.keyword === homeHippodrome?.keyword ? 'text-primary' : 'text-white'}`}>{data.location.split(' ')[0]}</p>
                                                {data.keyword === homeHippodrome?.keyword &&
                                                    <div className="tab-active-indicator"></div>}
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            <div className="tipster-not-found">
                <p className="text-xsmall">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                        <path
                            d="M39.9993 53.3333V40M39.9993 26.6666H40.0327M73.3327 40C73.3327 58.4095 58.4088 73.3333 39.9993 73.3333C21.5899 73.3333 6.66602 58.4095 6.66602 40C6.66602 21.5905 21.5899 6.66663 39.9993 6.66663C58.4088 6.66663 73.3327 21.5905 73.3327 40Z"
                            stroke="#929191" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                </p>
                <p className="text-xl text*bolder mb-3 mt-3">Günlük yorum bulunamadı.</p>
            </div>
        </>;
    }

    return <>
        {isMobile ?
            <div className="pb-5">
                <div className="page-title-wrapper ">
                    <HippodromeWidget/>
                </div>
                <div className="editord-mobile-container">
                    <div className={"d-flex w-100 overflow-scroll align-items-center"}>
                        {
                            tipsters.map((tipster: any, index: any) => {
                                return <div
                                    className={`tipster-selection ${selectedTipster.id === tipster.id ? 'selected' : ''}`}
                                    onClick={() => handleTipsterChange(tipster)}>
                                    <span>
                                        <img alt="editors-profile" loading="lazy"
                                             width="30" height="30" decoding="async"
                                             className="EditorReviews_editorIMG__OYjGA"
                                             src={tipstersData[tipster.id]?.avatar}
                                        />
                                    </span>
                                    <span
                                        className={`text-small text-bold ms-2 ${tipster.isOpen ? 'text-white' : ''}`}> {tipstersData[tipster.id]?.nick_name ?? `${tipstersData[tipster.id]?.first_name} ${tipstersData[tipster.id]?.last_name} `}</span>
                                </div>
                            })}

                    </div>


                    <div className="editord-mobile-table-wrapper">
                        <div className="editor-comment-wrapper">
                            {selectedTip?.run_tips.map((tip: any, index: any) => {
                                return <div className="editor-comment">
                                    <p className="text-xsmall text-bold pb-1">{tip.run}. Koşu</p>
                                    <p className="text-xsmall" dangerouslySetInnerHTML={{__html: tip.text}}></p>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div> :
            <>
                <div className="page-title-wrapper sticky-page-title">
                    <div className="hipodrome-tab-container">
                        <div className="container">
                            <div>
                                <div className={"hippodrome-scroller"}>
                                    <ScrollArrows scroller={scroller}/>
                                    <div className="tab-items-wrapper tab-items-scrollable" ref={scroller.ref}>
                                        {dailyRaces.map((data: any, key: any) => {
                                            return <div key={`available-hippodrome-${key}`}
                                                        className={`result-tab ${data.keyword === homeHippodrome?.keyword ? 'result-selected' : ''} `}
                                                        onClick={() => {
                                                            Object.assign(homeHippodrome, data);
                                                            homeHippodromeSubject.next(data);
                                                            MutualBetslip.setOptions({hippodrome: data});
                                                            forceUpdate();
                                                        }}>
                                                <div
                                                    className={`tab-item ${data.keyword === homeHippodrome?.keyword ? 'selected' : ''} `}>
                                                    <p className={`text-small text-bolder ${data.keyword === homeHippodrome?.keyword ? 'text-primary' : 'text-white'}`}>{data.location.split(' ')[0]}</p>
                                                    {data.keyword === homeHippodrome?.keyword &&
                                                        <div className="tab-active-indicator"></div>}
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="editord-mobile-container container">
                    <div className={"d-flex w-100 overflow-scroll align-items-center"}>
                        {
                            tipsters.map((tipster: any, index: any) => {
                                return <div
                                    className={`tipster-selection ${selectedTipster.id === tipster.id ? 'selected' : ''}`}
                                    onClick={() => handleTipsterChange(tipster)}>
                                    <span>
                                        <img alt="editors-profile" loading="lazy"
                                             width="30" height="30" decoding="async"
                                             className="EditorReviews_editorIMG__OYjGA"
                                             src={tipstersData[tipster.id]?.avatar}
                                        />
                                    </span>
                                    <span
                                        className={`text-small text-bold ms-2 ${tipster.isOpen ? 'text-white' : ''}`}> {tipstersData[tipster.id]?.nick_name ?? `${tipstersData[tipster.id]?.first_name} ${tipstersData[tipster.id]?.last_name} `}</span>
                                </div>
                            })}

                    </div>


                    <div className="editord-mobile-table-wrapper">
                        <div className="editor-comment-wrapper">
                            {selectedTip?.run_tips.map((tip: any, index: any) => {
                                return <div className="editor-comment">
                                    <p className="text-xsmall text-bold pb-1">{tip.run}. Koşu</p>
                                    <p className="text-xsmall" dangerouslySetInnerHTML={{__html: tip.text}}></p>
                                </div>
                            })}
                        </div>
                    </div>

                </div>
            </>

        }</>

}
